import { render, staticRenderFns } from "./Localized.vue?vue&type=template&id=6ca4c3d2&scoped=true&"
import script from "./Localized.vue?vue&type=script&lang=js&"
export * from "./Localized.vue?vue&type=script&lang=js&"
import style0 from "./Localized.vue?vue&type=style&index=0&id=6ca4c3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4c3d2",
  null
  
)

export default component.exports